module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover2-a254704a961e6ac105cbaa18e0934d49.jpg";